
































    import {Component, Prop, Provide, Vue } from 'vue-property-decorator';

    import EventPart from "../parallel-agendas/EventPart.vue"
    import CardsSection from "./cards-section/CardsSection.vue";
    import NotNowSections from "@share/program/components/parallel-agendas/not-now-sections/NotNowSections.vue"

    import {Element} from "@api/models/Element";
    import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
    import {ObjectRepository} from "@api/repositories/ObjectRepository";

    import { getImageUrl } from '@common/ImageUrlHelper';

    import { ProgramDataHelper } from '@share/program/helpers/ProgramDataHelper';
	import { EventInterface } from '@share/program/types/EventInterface';
    import { CardType } from '@share/common/cards/types/CardType';
    import {AsyncComponentFactory} from "vue/types/options";
    import { NoticeLevel } from '@service/components/toast/type/Enums';
    import { Notice } from '@service/components/toast/type/Notice';
    import { noticeActions } from '@service/store/notice/actions';

    // @ts-ignore
    const EventEdit: AsyncComponentFactory = () => {
        return {
            component: import( /* webpackChunkName: "partnerCreate" */ '@share/event-edit/EventEdit.vue'),
            delay: 120
        }
    }

    @Component({
        components: {EventEdit, EventPart, CardsSection, NotNowSections }
    })
    export default class ParallelAgendas extends Vue {
        @Prop({required: false, default: null}) programDataHelper: ProgramDataHelper | null;
        @Prop({required: true}) eventId: string;
        @Prop() sessions: Element[];
        @Prop() upcomingSessions: Element[];
        @Prop() pastSessions: EventInterface[];
        @Prop() backend: string;

        CardType = CardType;

        currentTimeZone = "";

        private objectRepository: ObjectRepository;
        private banner: null | any = null;

        created() {
            this.loadProgramBanners();
        }

        async loadProgramBanners() {

            this.objectRepository = this.$repositories.get(RepositoryFabric.OBJECT);

            const banners: any[] = (await this.objectRepository.query(process.env.VUE_APP_PROGRAM_BANNERS_SCHEMA || 'ProgramBanners', {
                where: {
                    eventId: this.eventId
                }
            }) as any[]);

            if(banners?.length) {
                this.banner = banners[0];
            }
        }

        @Provide()
        async deleteCardItem(id: string) {
            try {
                return await this.programDataHelper?.deleteSession(id);
            }
            catch(e) {
                this.$store.dispatch('reportException', e);

                const notice: Notice = {
                    text: this.$t("agenda.sessionDeleteFailed").toString(),
                    level: NoticeLevel.danger
                }

                this.$store.dispatch(noticeActions.submitNotice, notice);
            }
        }

        get partnersForBanner() {
            return this.programDataHelper?.exhibitionIds.map((partnerId) => this.partners.find((partner) => partnerId === partner.id)).filter(item => item)
        }

        get isOnEditing() {
            return this.$store.state.isOnEditing;
        }

        private get partners() {
            return this.programDataHelper?.exhibitions?.filter((partner) => partner.iconFileId) || [];
        }

        private get bannerUrl() {
            return getImageUrl(this.backend, this.banner?.imageFileId, 1980)
        }

        private get bannerActionUrl() {
            return this.banner?.url;
        }
    }

